<template>
  <div style="display: none">
    <md-field
      :key="name"
    >
      <label>{{ field.label }}</label>
      <md-input
        type="text"
        :key="name"
        :name="name"
        v-model="$vo[name].$model"
        disabled
      ></md-input>
    </md-field>
  </div>
</template>

<script>
  export default {
    name: "crud-id",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
      },
      $vo: {
        type: Object,
        required: true
      },
    },
    data() {
      return {}
    },
    computed: {
      isInvalid: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length && v.$invalid) result = true;
        return result;
      },
      hasRequirements: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length) result = true;
        return result;
      }
    },
    methods: {
      getV: function () {
        if (this.$vo && this.name && this.$vo[this.name] !== 'undefined') {
            return this.$vo[this.name] || false;
        } else {
          return false;
        }
      }
    }
  };
</script>
